import { useEffect } from "react";
import { ArrowLeft, X } from 'lucide-react';

const BigModal = ({ title, leftContent, rightContent, footerButton, onClose, onBack }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    return () => {
      document.body.style.overflow = "auto";
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, []);

  return (
    <div className="big-modal-overlay" onClick={onClose}>
      <div className="big-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="big-modal-header">
            <button className={`big-modal-back-icon ${!onBack ? 'big-modal-back-icon-hidden' : ''}`} onClick={onBack} style={{display: "flex", alignItems: "center"}}>
                <ArrowLeft size={30}/>
            </button>
            <div className="big-modal-header-title">{title}</div>
            <button className="big-modal-close-icon" onClick={onClose} style={{display: "flex", alignItems: "center"}}>
              <X size={30} />
            </button>
        </div>
        <div className="big-modal-body">
            <div className="big-modal-section left">{leftContent}</div>
            <div className="big-modal-divider"></div>
            <div className="big-modal-section right">{rightContent}</div>
        </div>
        <div className="big-modal-footer">{footerButton}</div>
      </div>
    </div>
  );
};

export default BigModal;